import { NgModule } from '@angular/core';
import { CoordinatorEQueryTitleComponent } from './e-query-details/e-query-title/coordinator-e-query-title.component';
import { CoordinatorEQueryDetailsDialogComponent } from './e-query-details/coordinator-e-query-details-dialog.component';
import { CommonModule } from '@angular/common';
import { CoordinatorEQueryDetailsStorage } from './e-query-details/coordinator-e-query-details-storage';
import { SharedModule } from '../../shared';
import { SimpleTextFieldModule } from '../../simple-text-field/simple-text-field.module';
import { CoordinatorEQueryEmailEscalationsComponent } from './e-query-details/email-escalations/coordinator-e-query-email-escalations.component';
import { EQueryCloseReasonsStorage } from './e-query-close-reasons-storage.service';
import { AuditTrailModule } from '../../audit-trail/audit-trail.module';
import { ReactiveFormsModule } from '@angular/forms';
import { EQueriesModule } from '../../e-queries/e-queries.module';
import { CovanceFileUploadModule } from '../../covance-file-upload/covance-file-upload.module';
import { AdminEQueryTabsComponent } from './e-query-tabs/admin-e-query-tabs.component';
import { AdminEQueryHideColumns } from './e-query-hide-unhide/admin-e-query-hide-columns';
import { EQueryHideStorage } from './e-query-hide-unhide/e-query-hide-storage.service';
import { EQueryHideReasonStorage } from './e-query-hide-unhide/e-query-hide-reason-storage';
import { EQueryUnhideReasonStorage } from './e-query-hide-unhide/e-query-unhide-reason-storage';
import { AdminEQueryHideComponent } from './e-query-hide-unhide/admin-e-query-hide.component';
import { EQueryHideDialogComponent } from './e-query-hide-unhide/hide-dialog/e-query-hide-dialog.component';
import { AdminEscalationEmailsComponent } from './admin-escalations/admin-escalation-emails.component';
import { CoordinatorEQueryTabsComponent } from './e-query-tabs/coordinator-e-query-tabs.component';
import { AdminEQueryEscalationsStorage } from './admin-e-query-escalations-storage';
import { CovanceAgGridModule } from '../../covance-ag-grid/covance-ag-grid.module';
import { GlobalPopupModule} from '../../global-popup';
import { EscalationEmailsFilterComponent } from './admin-escalations/escalation-emails-filter/escalation-emails-filter.component';
import { AdminEQueryEscalationsFilterResolver } from './admin-e-query-escalations-filter-resolver';
import { CovanceFilterModule } from '../../covance-filter/covance-filter.module';
import { AdminEQueryEscalationSearchFieldsStorage } from './admin-e-query-escalation-search-fields-storage';
import { EscalationSearchFieldComponent } from './admin-escalations/escalation-search-field/escalation-search-field.component';
import { HideMenuAgRendererComponent } from './e-query-hide-unhide/hide-menu-ag-renderer.component';
import { NewEscalationDialogComponent } from './admin-escalations/new-escalation-dialog/new-escalation-dialog.component';
import { AdminSharedModule } from '../admin-shared.module';
import { EscalationLevelSelectComponent } from './escalation-level-select/escalation-level-select.component';
import { DeleteEscalationDialogComponent } from './admin-escalations/delete-escalation-dialog/delete-escalation-dialog.component';
import { EscalationRemovalButtonAgRenderer } from './admin-escalations/escalation-removal-button-ag-renderer.component';
import { AdminPrefilledEQueryEditComponent } from './prefiled-query-edit/admin-prefilled-e-query-edit.component';
import { EscalationsComponent } from './escalations/escalations.component';
import { CommentsComponent } from './comments/comments.component';
import { EscalationMailComponent } from './e-mails/escalation-mail.component';
import { EscalationMailEmitter} from './e-mails/escalation-mail-emitter';
import { QuillModule } from 'ngx-quill';
import { EQueryQuestionsComponent } from './e-query-details/questions/e-query-questions.component';
import { EQueryStageStorage } from './prefiled-query-edit/e-query-stage-storage';
import { AdminUsageEQueryReportComponent } from './usage-reports/admin-usage-e-query-report.component';
import { AdminUsageEQueryFilterComponent } from './usage-reports/admin-usage-e-query-filter/admin-usage-e-query-filter.component';
import { AdminUsageEQueryReportDataComponent } from './usage-reports/admin-usage-e-query-report-data/admin-usage-e-query-report-data.component';
import { AdminUsageEQueriesReportFilterItems } from './usage-reports/admin-usage-e-queries-report-filter-items';
import { AdminPrefilledActiveEQueryEditComponent } from './prefiled-query-edit/admin-prefilled-active-e-query-edit.component';
import { ActiveEQueryComponent } from './prefiled-query-edit/active-e-query/active-e-query.component';
import { ActiveEQueryQuestionsComponent } from './prefiled-query-edit/active-e-query-questions/active-e-query-questions.component';
import { ActiveEQueryAttachmentsComponent } from './prefiled-query-edit/active-e-query-attachments/active-e-query-attachments.component';
import { EQueryAttachmentsUploaderComponent } from './prefiled-query-edit/e-query-attachments-uploader/e-query-attachments-uploader.component';
import { HideEqueryFilterComponent } from './e-query-hide-unhide/hide-filter/hide-equery-filter.component';
import {UsageEQueryReportFilterItemsResolver} from './usage-reports/usage-e-query-report-filter-items-resolver';

export const COMPONENTS = [
    CoordinatorEQueryTitleComponent,
    CoordinatorEQueryDetailsDialogComponent,
    CoordinatorEQueryEmailEscalationsComponent,
    CoordinatorEQueryTabsComponent,
    AdminEQueryTabsComponent,
    AdminEQueryHideComponent,
    AdminEscalationEmailsComponent,
    EscalationEmailsFilterComponent,
    EscalationSearchFieldComponent,
    EQueryHideDialogComponent,
    HideMenuAgRendererComponent,
    NewEscalationDialogComponent,
    EscalationLevelSelectComponent,
    DeleteEscalationDialogComponent,
    EscalationRemovalButtonAgRenderer,
    AdminPrefilledEQueryEditComponent,
    EscalationsComponent,
    CommentsComponent,
    EscalationMailComponent,
    EQueryQuestionsComponent,
    AdminUsageEQueryReportComponent,
    AdminUsageEQueryFilterComponent,
    AdminUsageEQueryReportDataComponent,
    AdminPrefilledActiveEQueryEditComponent,
    ActiveEQueryComponent,
    ActiveEQueryQuestionsComponent,
    ActiveEQueryAttachmentsComponent,
    EQueryAttachmentsUploaderComponent,
    HideEqueryFilterComponent,
];

@NgModule({
    declarations: [COMPONENTS],
    exports: [COMPONENTS],
    imports: [
        CommonModule,
        SharedModule,
        SimpleTextFieldModule,
        AuditTrailModule,
        ReactiveFormsModule,
        EQueriesModule,
        QuillModule,
        CovanceFileUploadModule,
        CovanceAgGridModule,
        GlobalPopupModule,
        CovanceFilterModule,
        AdminSharedModule,
        CovanceFilterModule,
        CovanceFileUploadModule
    ],
    entryComponents: [
        CoordinatorEQueryDetailsDialogComponent,
        EQueryHideDialogComponent,
        HideMenuAgRendererComponent,
        NewEscalationDialogComponent,
        DeleteEscalationDialogComponent,
        EscalationRemovalButtonAgRenderer,
    ],
    providers: [
        CoordinatorEQueryDetailsStorage,
        EQueryCloseReasonsStorage,
        AdminEQueryEscalationsStorage,
        EscalationMailEmitter,
        EQueryHideStorage,        
        EQueryHideReasonStorage,
        EQueryUnhideReasonStorage,
        AdminEQueryHideColumns,
        AdminEQueryEscalationsFilterResolver,
        AdminEQueryEscalationSearchFieldsStorage,
        EQueryStageStorage,
        AdminUsageEQueriesReportFilterItems,
        UsageEQueryReportFilterItemsResolver
    ]
})
export class AdminEQueryModule {}
